import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

const IconAlertSquareRounded = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='auto'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z' />
    <path d='M12 8v4' />
    <path d='M12 16h.01' />
  </Icon>
);

export default IconAlertSquareRounded;
